import InfoMessageWithSeeMore, { InfoMessageWithSeeMoreProps } from './InfoMessageWithSeeMore';

export default InfoMessageWithSeeMore;
export type { InfoMessageWithSeeMoreProps };
